import React, {useEffect, useRef, useState} from "react";
import {Tooltip, Typography, TypographyProps} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";
import clsx from "clsx";

const TooltipTitle = ({
  name,
  className,
  textProps,
}: {
  name: string;
  className?: string;
  textProps?: TypographyProps;
}) => {
  const classes = useStyles();
  const textRef = useRef<HTMLSpanElement | null>(null);
  const [shouldHover, setShouldHover] = useState<boolean>(false);
  useEffect(() => {
    const handleHover = () => {
      if (!textRef.current) {
        return;
      }
      const {scrollHeight, clientHeight} = textRef.current;
      const isOverflowing = scrollHeight > clientHeight;
      setShouldHover(isOverflowing);
    };

    handleHover();
    window.addEventListener("resize", handleHover);
    return () => window.removeEventListener("resize", handleHover);
  }, []);
  return (
    <Tooltip
      disableFocusListener
      disableTouchListener
      disableHoverListener={!shouldHover}
      title={name}
    >
      <Typography
        variant="h5"
        className={clsx(classes.title, className)}
        ref={textRef}
        {...textProps}
      >
        {name}
      </Typography>
    </Tooltip>
  );
};
const useStyles = makeStyles(() => ({
  title: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    wordBreak: "break-word",
    maxWidth: "100%",
    display: "-webkit-box",
    WebkitLineClamp: 1,
    WebkitBoxOrient: "vertical",
    whiteSpace: "normal",
    lineHeight: 1.3,
  },
}));
export default TooltipTitle;
